import { Lookbook } from '@/types/lookbook';
import React, { FC } from 'react'
import LookbookShowcaseCard from './LookbookShowcaseCard';
import { HStack, Link, SimpleGrid, Stack, Text, useBreakpointValue } from '@chakra-ui/react';
import { I18nLink } from '../i18n/I18nLink';
import { useTranslations } from "next-intl";

interface LookbookShowcaseProps {
  items: Lookbook[];
}

const LookbookShowcase: FC<LookbookShowcaseProps> = ({ items }) => {
  const t = useTranslations();
  const isMobile = useBreakpointValue({ base: true, sm: true, md: false });
  return (
    <Stack gap={{ base: "40px", md: "40px" }}>
      <HStack justify="space-between">
        <Text textStyle="bold16">{t('lookbook')}</Text>
        <Link as={I18nLink} href={"/shop/lookbook"} textStyle={"bold16"} color="brand" visibility={{ base: "hidden", md: "visible" }}>{t('view_all')}</Link>
      </HStack>
      <SimpleGrid
        columns={{ base: Math.min(2, items.length), sm: Math.min(3, items.length), md: Math.min(4, items.length) }}
        gap={{ base: "4px", md: "20px" }}
        mb={8}
      >
        {items.slice(0, isMobile ? 6 : 8).map(item => (
          <LookbookShowcaseCard key={item.id} lookbook={item} />
        ))}
      </SimpleGrid>
    </Stack>
  )
}

export default LookbookShowcase;